__turbopack_context__.v({
  "className": "hind_949bfdf8-module__nPq2xq__className",
  "variable": "hind_949bfdf8-module__nPq2xq__variable",
});
